export default __webpack_public_path__ + "static/media/txt.df7205b1.png";